import {Phone, MessageCircleDashed as MessageCircle} from 'lucide-react'

export default function StickyCallButton() {
  return (
    <>
      {/* Mobile: bottom bar */}
      <div className="lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-white/95 backdrop-blur border-t border-navy-100 shadow-elevated px-3 py-2.5 safe-area-inset-bottom">
        <div className="flex items-center gap-2">
          <a
            href="tel:+41796430399"
            className="flex-1 inline-flex items-center justify-center gap-2 px-4 py-3 rounded-xl gradient-urgent text-white font-bold text-sm shadow-orange-glow"
          >
            <Phone className="w-4 h-4" strokeWidth={2.5} />
            Appeler 24/7
          </a>
          <a
            href="https://wa.me/41796430399"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-[#25D366] text-white shadow-soft"
            aria-label="WhatsApp"
          >
            <MessageCircle className="w-5 h-5" strokeWidth={2.5} />
          </a>
        </div>
      </div>

      {/* Desktop: floating */}
      <div className="hidden lg:flex fixed bottom-6 right-6 z-40 flex-col items-end gap-3">
        <a
          href="https://wa.me/41796430399"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 px-4 py-3 rounded-full bg-[#25D366] hover:bg-[#1eb858] text-white font-semibold text-sm shadow-elevated transition-colors"
        >
          <MessageCircle className="w-4 h-4" strokeWidth={2.5} />
          WhatsApp
        </a>
        <a
          href="tel:+41796430399"
          className="inline-flex items-center gap-2 px-5 py-3.5 rounded-full gradient-urgent text-white font-bold text-sm shadow-orange-glow animate-pulse-ring"
        >
          <Phone className="w-4 h-4" strokeWidth={2.5} />
          079 643 03 99
        </a>
      </div>

      {/* Spacer for mobile */}
      <div className="lg:hidden h-20" aria-hidden="true" />
    </>
  )
}
